import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { DEFAULT_PRIMARY, DEFAULT_THEME, PRIMARY_OPTIONS, THEME_OPTIONS } from '../theme/themeConfig';

const ThemeContext = createContext(null);

const THEME_KEY = 'sfb-theme-mode';
const PRIMARY_KEY = 'sfb-theme-primary';

const isValidTheme = value => THEME_OPTIONS.some(({ id }) => id === value);
const isValidPrimary = value => PRIMARY_OPTIONS.some(({ id }) => id === value);

const getInitialTheme = () => {
  const storedValue = window.localStorage.getItem(THEME_KEY);
  return isValidTheme(storedValue) ? storedValue : DEFAULT_THEME;
};

const getInitialPrimary = () => {
  const storedValue = window.localStorage.getItem(PRIMARY_KEY);
  return isValidPrimary(storedValue) ? storedValue : DEFAULT_PRIMARY;
};

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(getInitialTheme);
  const [primary, setPrimary] = useState(getInitialPrimary);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    window.localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  useEffect(() => {
    document.documentElement.setAttribute('data-primary', primary);
    window.localStorage.setItem(PRIMARY_KEY, primary);
  }, [primary]);

  const value = useMemo(() => ({
    theme,
    setTheme,
    primary,
    setPrimary,
  }), [theme, primary]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }

  return context;
}
